/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, count: NonNullable<unknown> }} Coaching_Day_LineInputs */

const en_us2_coaching_day_line = /** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · exercises: ${i?.count}`)
};

const pt_br2_coaching_day_line = /** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · exercícios: ${i?.count}`)
};

const pt_pt2_coaching_day_line = /** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · exercícios: ${i?.count}`)
};

/** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */
const es_419_coaching_day_line = en_us2_coaching_day_line;

/** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */
const fr_fr2_coaching_day_line = en_us2_coaching_day_line;

/** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */
const de_de2_coaching_day_line = en_us2_coaching_day_line;

/** @type {(inputs: Coaching_Day_LineInputs) => LocalizedString} */
const it_it2_coaching_day_line = en_us2_coaching_day_line;

/**
* | output |
* | --- |
* | "{label} · exercises: {count}" |
*
* @param {Coaching_Day_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_day_line = /** @type {((inputs: Coaching_Day_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Day_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_day_line(inputs)
	if (locale === "es-419") return es_419_coaching_day_line(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_day_line(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_day_line(inputs)
	if (locale === "de-DE") return de_de2_coaching_day_line(inputs)
	if (locale === "it-IT") return it_it2_coaching_day_line(inputs)
	return en_us2_coaching_day_line(inputs)
});
export { coaching_day_line as "coaching.day_line" }